var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.395287e7ce2f455d9e88668152991710.svg#6';
                    var viewUrl = 'sprites.395287e7ce2f455d9e88668152991710.svg#view-6';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 55 37',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };